import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import update from "immutability-helper";
import { I18n } from "@aws-amplify/core";
import { get, filter, map, includes, isEmpty, forEach } from "lodash";

import { fetchPost } from "../../../api/fetch";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import Loader from "../../Common/Loader";
import WalkInOutForm from "./WalkInOutForm";
import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";

import {
  fetchLogsTabNew,
  getLatestLog,
} from "../../../actions/siteEntranceExit/tabs";

import { getLov } from "../../../utils/lov";
import { dbFormat } from "../../../utils/date";
import { getAttributeValue } from "../../../utils/profile";

import { walkInOut } from "../../../constants/reducers";
import { LOG_EVENT_GROUP_TYPES } from "../../../constants/logEventGroupTypes";
import { STATIC_TAB } from "../../../constants/siteEntranceExit";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    minWidth: "770px",
    maxHeight: "calc(100vh - 60px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: "12px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1.142em",
    color: colors.black87,
    textAlign: "center",
    textTransform: "uppercase",
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
  },
  menuItem: {
    padding: "15px 20px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  itemIcon: {
    width: "35px",
    minWidth: "unset",
    marginRight: "15px",
  },
  actionButton: {
    margin: "10px",
  },
};

const AddWalkInOut = (props) => {
  const { classes, dispatch, language } = props;
  const [open, setOpen] = React.useState(false);
  const [lov, setLov] = React.useState({});
  const [eventGroupType, setEventGroupType] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [formValues, setFormValues] = React.useState({
    dateType: "current",
    date: Date.now(),
  });
  const [verification, setVerification] = React.useState();
  const [temperature, setTemperature] = React.useState();
  const [saving, setSaving] = React.useState(false);

  const zoneTab = get(props, ["match", "params", "zoneId"]);

  React.useEffect(() => {
    if (zoneTab && open) {
      handleChange("zone", null, parseInt(zoneTab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneTab, open]);

  React.useEffect(() => {
    const fetchEventGroupTypes = async () => {
      try {
        let eventGroupTypes = await getLov("eventGroupTypes");
        eventGroupTypes = filter(eventGroupTypes, (t) =>
          includes(get(LOG_EVENT_GROUP_TYPES, walkInOut), t.id)
        );
        setLov({
          eventGroupTypes,
          158: await getLov(158),
          105: await getLov(105),
        });
      } catch (e) {
        console.log(e);
      }
    };
    fetchEventGroupTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeDialog = () => {
    setFormValues({
      dateType: "current",
      date: Date.now(),
    });
    setVerification();
    setTemperature();
    setOpen(false);
  };

  const handleChange = (id, index, value) => {
    if (id === "date") {
      setFormValues(
        update(formValues, {
          [id]: { $set: new Date(value).getTime() },
        })
      );
    } else if (id === "dateType" && value === "current") {
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
          date: { $set: Date.now() },
        })
      );
    } else if (id === "zone") {
      setFormValues(
        update(formValues, {
          zone: { $set: value },
          site: { $set: index },
        })
      );
    } else {
      if (id === "profile") {
        setVerification();
      }
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
        })
      );
    }
  };

  const isValidForm = () => {
    let valid = true;
    if (!get(formValues, ["zone"])) valid = false;
    if (!get(formValues, ["profile"])) valid = false;
    if (!get(formValues, ["date"])) valid = false;
    //if (!get(formValues, ["lukeAction"])) valid = false;
    return valid;
  };

  const submit = async (decision) => {
    try {
      setSaving(true);
      let date =
        get(formValues, ["dateType"]) === "current"
          ? Date.now()
          : get(formValues, ["date"]);

      let body = {
        type_id: get(eventGroupType, ["id"]),
        profile_id: get(formValues, ["profile", "id"]),
        active: true,
        description: get(formValues, ["note"]),
        site_id: get(formValues, ["site"]),
        zone_id: get(formValues, ["zone"]),
        attributes: [
          {
            id: get(eventGroupType, ["id"]) === 4 ? 76 : 77,
            value: dbFormat(date, "YYYY-MM-DD[T]HH:mm:ss.SS[Z]"),
          },
          {
            id: 105,
            value: decision,
          },
        ],
      };

      // Add Verifications
      if (!isEmpty(get(verification, ["verificationEventGroup"]))) {
        let actionId = get(formValues, ["lukeAction"]);
        let actionString = get(
          filter(
            get(lov, [158]),
            (item) => item.id === get(formValues, ["lukeAction"])
          ),
          [0, `name_${language}`]
        );
        let actionColor =
          decision === 43 ? "00FF00" : decision === 44 ? "FF0000" : "FFA500";
        let actionColorId = decision === 43 ? 0 : decision === 44 ? 2 : 3;

        let surveyEvent = get(verification, ["surveyEvent"]);
        let attr151 = JSON.parse(
          get(
            filter(get(surveyEvent, ["attributes"]), (attr) => attr.id === 151),
            [0, "value"]
          )
        );
        attr151.survey_instructions.id = actionColorId;
        attr151.survey_instructions.color = actionColor;
        attr151.survey_instructions.instruction = actionString;
        attr151.instruction_id = actionId;
        attr151.decision_id = decision;

        // Add thermal info to JSON
        if (get(temperature, ["temperatureEventGroup"])) {
          attr151.thermal = [
            {
              timestamp: get(temperature, ["temperatureEventGroup", "start"]),
              event: "manual",
              capture: {
                success: 1,
                temperature: {
                  avg: getAttributeValue(
                    get(temperature, ["measureTemperatureEvent"]),
                    187
                  ),
                },
              },
            },
          ];
        }

        surveyEvent.attributes = [
          ...filter(surveyEvent.attributes, (attr) => attr.id !== 151),
          { id: 151, value: JSON.stringify(attr151) },
        ];

        body.verification = {
          lukeAction: {
            attributes: [
              {
                id: 158,
                value: actionId,
              },
              {
                id: 159,
                value: JSON.stringify({
                  id: actionColorId,
                  profile_id: get(formValues, ["profile", "id"]),
                  completed: true,
                  reason: null,
                  color: actionColor,
                  instruction: actionString,
                }),
              },
            ],
          },
          survey: {
            attributes: get(surveyEvent, ["attributes"]),
          },
        };
      }

      // Add Temperature
      if (!isEmpty(get(temperature, ["temperatureEventGroup"]))) {
        body.thermal = {
          note: get(temperature, ["temperatureEventGroup", "description"]),
          attributes: get(temperature, [
            "measureTemperatureEvent",
            "attributes",
          ]),
        };
      }

      await fetchPost("/walkinout/event_groups", body);

      if (!zoneTab) {
        dispatch(fetchLogsTabNew(walkInOut, 0, null));
      } else {
        let tabs = get(props, ["siteEntranceExit", walkInOut, "tabs"]);
        let index;
        forEach(tabs, (t, i) => {
          if (
            get(t, ["type"]) === STATIC_TAB &&
            get(t, ["zone", "id"]) === parseInt(zoneTab)
          ) {
            index = i;
          }
        });
        dispatch(getLatestLog(walkInOut, index));
      }

      closeDialog();
    } catch (e) {
      console.log(e);
    }
    setSaving(false);
  };

  const onSubmitVerification = (
    verificationEventGroup,
    surveyEvent,
    lukeActionEvent,
    verification
  ) => {
    setVerification({
      verificationEventGroup,
      surveyEvent,
      lukeActionEvent,
      verification,
    });
  };

  const onSubmitTemperature = (
    temperatureEventGroup,
    measureTemperatureEvent
  ) => {
    setTemperature({
      temperatureEventGroup,
      measureTemperatureEvent,
    });
  };

  return (
    <>
      <Box style={{ margin: "27px 30px 0px 0px" }}>
        <img
          src={images.plusIconColored}
          alt="add"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          style={{ cursor: "pointer" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
        />
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {map(get(lov, ["eventGroupTypes"]), (type, index) => (
            <MenuItem
              key={index}
              classes={{ root: classes.menuItem }}
              alignItems="center"
              onClick={() => {
                setAnchorEl(null);
                setEventGroupType(type);
                setOpen(true);
              }}
              style={{ paddingLeft: "0px !important" }}
            >
              <ListItemIcon
                classes={{ root: classes.itemIcon }}
                style={{ display: "flex", justifyContent: "center" }}
              >
                {includes(get(LOG_EVENT_GROUP_TYPES, walkInOut), type.id) && (
                  <img
                    src={
                      type.id === 4
                        ? images.walkInIcon
                        : type.id === 5
                        ? images.walkOutIcon
                        : null
                    }
                    height="20px"
                    style={{ maxWidth: "35px" }}
                    alt="event_icon"
                  />
                )}
              </ListItemIcon>
              {type[`name_${language}`]}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Dialog
        open={open}
        classes={{
          root: classes.dialogRoot,
          paperScrollPaper: classes.dialog,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {`${I18n.get("site_newEntry")} - ${get(eventGroupType, [
                  `name_${language}`,
                ])}`}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={closeDialog} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            style={{ maxHeight: "calc(100vh - 120px)", overflow: "auto" }}
          >
            {saving ? (
              <Loader
                noDecoration
                height="300px"
                message={I18n.get("profiles_saving")}
              />
            ) : (
              <Grid container direction="column" wrap="nowrap">
                <Grid item>
                  <WalkInOutForm
                    formValues={formValues}
                    handleChange={handleChange}
                    language={language}
                    onSubmitVerification={onSubmitVerification}
                    verification={verification}
                    onSubmitTemperature={onSubmitTemperature}
                    temperature={temperature}
                    lov={lov}
                    eventGroupTypeId={get(eventGroupType, ["id"])}
                  />
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                  }}
                >
                  <CustomButton
                    className={classes.actionButton}
                    variant="contained"
                    startIcon={
                      <img
                        src={
                          isValidForm() ? images.deniedWhite : images.deniedGrey
                        }
                        alt="deny"
                      />
                    }
                    disabled={!isValidForm()}
                    style={{
                      backgroundColor: isValidForm() ? colors.errorRed : null,
                      color: isValidForm() ? colors.white : null,
                      minWidth: "100px",
                    }}
                    onClick={() => submit(44)}
                  >
                    {I18n.get("site_deny")}
                  </CustomButton>
                  <CustomButton
                    className={classes.actionButton}
                    variant="contained"
                    startIcon={
                      <img
                        src={
                          isValidForm()
                            ? images.requireAssistanceWhite
                            : images.requireAssistanceGrey
                        }
                        alt="require_assistance"
                      />
                    }
                    disabled={!isValidForm()}
                    style={{
                      backgroundColor: isValidForm()
                        ? colors.selectedOrange
                        : null,
                      color: isValidForm() ? colors.white : null,
                      minWidth: "100px",
                    }}
                    onClick={() => submit(93)}
                  >
                    {I18n.get("dashboard_requireAssistance")}
                  </CustomButton>
                  <CustomButton
                    className={classes.actionButton}
                    variant="contained"
                    startIcon={
                      <img
                        src={
                          isValidForm()
                            ? images.allowedWhite
                            : images.allowedGrey
                        }
                        alt="allowed"
                      />
                    }
                    disabled={!isValidForm()}
                    style={{
                      backgroundColor: isValidForm() ? colors.cardGreen : null,
                      color: isValidForm() ? colors.white : null,
                      minWidth: "100px",
                    }}
                    onClick={() => submit(43)}
                  >
                    {I18n.get("site_allow")}
                  </CustomButton>
                </Grid>
                <Grid
                  item
                  className="text-center"
                  style={{ margin: "10px 0px 20px" }}
                >
                  <CustomButton color="primary" onClick={closeDialog}>
                    {I18n.get("site_cancel")}
                  </CustomButton>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: get(state, ["siteEntranceExit"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(AddWalkInOut))
);
